import drones from './drones';
import detector from './detector';
import arial_awareness from './arial-awareness';
import crowdsource from './nostradamus/crowdsource';
import units from './units';
import unmanned_aerial_vehicles from './nostradamus/unmanned-aerial-vehicles';
import administration from './nostradamus/administration';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [
        drones,
        detector,
        arial_awareness,
        crowdsource,
        units,
        unmanned_aerial_vehicles,
        administration,
    ],
};

export default menuItems;
